import { Box, CircularProgress, IconButton, Tab, Tabs } from '@mui/material'
import { rgba } from 'polished';
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { setSelectedElementDetails } from '../../../FloorManagement/addSeat/addSeatSlice';
import { Rnd } from 'react-rnd';
import { shapeTypes, structures, decorTypes } from '../../../FloorManagement/utils/floorManagementEnum';
import LineSegmentTool from '../../../FloorManagement/components/icons/LineSegmentTool';
import StarTool from '../../../FloorManagement/components/icons/StarTool';
import Chair from '../../../FloorManagement/components/icons/Chair';
import PlantIcon from '../../../FloorManagement/components/icons/PlantIcon';
import TreeIcon from '../../../FloorManagement/components/icons/TreeIcon';
import FlowerIcon from '../../../FloorManagement/components/icons/FlowerIcon';
import FountainIcon from '../../../FloorManagement/components/icons/FountainIcon';
import StatueIcon from '../../../FloorManagement/components/icons/StatueIcon';
import LampIcon from '../../../FloorManagement/components/icons/LampIcon';
import TopBar from './TopBar';
import { addOrderFromFloorAPI, getFloorDetailsForBilling, updateOrderTablesAPI } from '../API/billingFloorSection';
import { getCurrentTime, today } from '../../../../../Js/Date';
import { setErrorSnack, setOrderIdInPOS, setSnackMsg, setSingleOrderInfo } from '../Slice/billingScreenSlice';
import { setBtnSelected } from './topBarSliceBilling';
import useTabWidth from '../../../FloorManagement/hooks/useTabWidth';
import HomeIcon from '@mui/icons-material/Home';
import ReceiptIcon from '@mui/icons-material/Receipt';

// Texture styles for tables
const textureStyles = {
  wood: "linear-gradient(135deg, #8B4513 0%, #A0522D 25%, #8B4513 50%, #CD853F 75%, #8B4513 100%)",
  marble: "linear-gradient(135deg, #f5f5f5 0%, #e0e0e0 25%, #f5f5f5 50%, #bdbdbd 75%, #f5f5f5 100%)",
  glass: "linear-gradient(135deg, rgba(173, 216, 230, 0.6) 0%, rgba(135, 206, 235, 0.4) 50%, rgba(173, 216, 230, 0.6) 100%)",
  metal: "linear-gradient(135deg, #71797E 0%, #A9A9A9 25%, #71797E 50%, #C0C0C0 75%, #71797E 100%)",
  granite: "linear-gradient(135deg, #2F4F4F 0%, #696969 25%, #2F4F4F 50%, #808080 75%, #2F4F4F 100%)",
};

// Helper function to get delay-based colors for order badges
// Uses same logic as TimerColumn for consistency
const getOrderDelayColors = (orderDate, orderTime) => {
  const defaultColors = { background: '#fff', textColor: '#333', iconColor: '#4CAF50', kotColor: '#f57c00' };
  
  if (!orderDate) return defaultColors;
  
  try {
    let orderDateTime;
    
    // Handle Unix timestamp (Number) - stored as milliseconds or seconds
    if (typeof orderDate === 'number') {
      // If timestamp is in seconds (10 digits), convert to milliseconds
      orderDateTime = new Date(orderDate < 10000000000 ? orderDate * 1000 : orderDate);
    } else if (typeof orderDate === 'string') {
      // Handle string formats
      if (orderDate.includes(' ')) {
        // Format: "YYYY-MM-DD HH:MM:SS"
        orderDateTime = new Date(orderDate.replace(' ', 'T'));
      } else if (orderTime) {
        // Separate date and time
        orderDateTime = new Date(`${orderDate}T${orderTime}`);
      } else {
        orderDateTime = new Date(orderDate);
      }
    } else {
      return defaultColors;
    }
    
    if (isNaN(orderDateTime.getTime())) {
      return defaultColors;
    }
    
    const now = new Date();
    const diffMs = now - orderDateTime;
    const diffMinutes = Math.floor(diffMs / 60000);
    
    if (diffMinutes >= 15) {
      // Red - critical delay (15+ minutes)
      return { background: '#d32f2f', textColor: '#fff', iconColor: '#fff', kotColor: '#ffcdd2' };
    } else if (diffMinutes >= 10) {
      // Light red - warning delay (10-15 minutes)
      return { background: '#ef5350', textColor: '#fff', iconColor: '#fff', kotColor: '#ffcdd2' };
    } else if (diffMinutes >= 3) {
      // Light orange - slight delay (3-10 minutes)
      return { background: '#ff9800', textColor: '#fff', iconColor: '#fff', kotColor: '#ffe0b2' };
    } else {
      // Default - no delay (under 3 minutes)
      return defaultColors;
    }
  } catch (e) {
    return defaultColors;
  }
};

function BillingFloorPlan() {

    const dispatch=useDispatch()

    const userShiftStatus = localStorage.getItem("shiftStatus");
    const defaultFloorId=localStorage.getItem("defaultFloorId");

    //Redux states 
    // login response
    const userInfo = useSelector((state) => state.loginResponseSlice.value);
   
   // all floor list of a branch
    const { floors } = useSelector((state) => state.addSeatSlice);
    const tabWidth = useTabWidth(floors?.length);


    const { selectedFloorDetails } = useSelector((store) => store.billingFloorPlanSlice);
    const { customer,defaultCustomer,btnClicked } = useSelector((store) => store.topBarSliceBilling);
    const {orderIdForPos,singleOrderInfo} = useSelector((store) => store.billingScreenSlice);
    const {branchConfigurationList} = useSelector((state) => state.newBillingSlice);

    // useStates
    const [floorSelected, setFloorSelected] = useState(null)
    const [floorLoading,setFloorLoading]=useState(false)
    const [selectedTables,setSelectedTables]=useState([])
    const [selectedChairs,setSelectedChairs]=useState([])
    const [floorId,setFloorId]=useState(null)
    const [orderIdColorMapping, setOrderIdColorMapping] = useState({});
    const [tableOrder,setTableOrders] = useState([])
    const [initialColors,setInitialColors]=useState({})


    // Use polished's rgba function to decrease opacity of selected floor
    const getSelectedTabColor = (originalColor) => {
        try {
            return rgba(originalColor, 0.5);
        } catch (error) {
            return rgba("#f67878", 0.5);
        }
    };

    const clearTableOrderStates=()=>{
        setSelectedTables([]);
        setSelectedChairs([])
        dispatch(setOrderIdInPOS(null))
        setOrderIdColorMapping({})
        setInitialColors({})
    }
    // Set floor tab details
    const handleTabDetails = (res) => {

        dispatch(setSelectedElementDetails({ ...res, isFloor: true }));
        getFloorDetailsForBilling({ id: res._id, branchId: userInfo?.branchPk },clearTableOrderStates);
        setFloorId(res._id)
        localStorage.setItem("defaultFloorId", res._id)
        
    };
//   function -chair and table-selection
    const handleShapeSelected = (shape)  => {
        if(shape.isUsed){
            if(selectedTables.length!==0){
                dispatch(setSnackMsg("Seat already in use !!"))
                dispatch(setErrorSnack(true))
            }else{
                dispatch(setOrderIdInPOS(orderIdForPos=== getFirstObject(shape?.orders)?null:getFirstObject(shape?.orders)))
            }
        }
        else if(orderIdForPos===null){
        if (shape.type === "CHAIR") {
            let seatSelection=selectedFloorDetails?.seatSelection
            if(seatSelection){
                const chairSelected = selectedChairs.some((obj) => obj === shape?._id);
                if (chairSelected) {
                    const updatedSelectedObjects = selectedChairs.filter((obj) => obj !== shape._id);
                    setSelectedChairs(updatedSelectedObjects);
                    // setSelectedTables(updatedSelectedTable)
                } else {
                    setSelectedChairs([...selectedChairs, shape._id]);
                    setSelectedTables([...selectedTables, shape.tableId]);
                }
            }else{
                dispatch(setSnackMsg("Chair selection disabled for this floor"))
                dispatch(setErrorSnack(true))
            }
           
        }
        else if(shape.type==="TABLE"){
            const tableSelected = selectedTables.some((obj) => obj === shape._id);
            if (tableSelected) {
                const updatedSelectedObjects = selectedTables.filter((obj) => obj !== shape._id);
                const filteredChairs = selectedChairs.filter(chairId => {
                    const matchingObject = selectedFloorDetails?.floorCanvas.find(obj => obj._id === chairId);
                    return !matchingObject || matchingObject.tableId !== shape._id;
                  });

                setSelectedTables(updatedSelectedObjects);
                setSelectedChairs(filteredChairs)
            } else {
                setSelectedTables([...selectedTables, shape._id]);

                // Find matching Chairs based on the selected tableId 
                const filteredIds = selectedFloorDetails?.floorCanvas
                    .filter((obj) => obj.tableId === shape._id)
                    .map((obj) => obj._id);

                const uniqueIds = new Set(selectedChairs.concat(filteredIds));

                uniqueIds.size !== 0 && setSelectedChairs([...uniqueIds]);
            }
        }
        }
    }   
//   function -chair and table-update on an order
    const tableShiftClicked = (shape) => {

        let existing = selectedTables.includes(shape.tableId || shape._id) || getFirstObject(shape?.orders) === orderIdForPos
        if ((shape.isUsed && !existing)) {
            dispatch(setSnackMsg("Seat already in use !!"))
            dispatch(setErrorSnack(true))
        }
        else {
            if (shape.type === "CHAIR") {
                const chairSelected = selectedChairs.some((obj) => obj === shape._id);
                if (chairSelected) {
                    const updatedSelectedObjects = selectedChairs.filter((obj) => obj !== shape._id);
                    setSelectedChairs(updatedSelectedObjects);
                    // setSelectedTables(updatedSelectedTable)
                } else {
                    setSelectedChairs([...selectedChairs, shape._id]);
                    setSelectedTables([...selectedTables, shape.tableId]);
                }
            }
            else if (shape.type === "TABLE") {
                const tableSelected = selectedTables.some((obj) => obj === shape._id);
                if (tableSelected) {
                    const updatedSelectedObjects = selectedTables.filter((obj) => obj !== shape._id);
                    const filteredChairs = selectedChairs.filter(chairId => {
                        const matchingObject = selectedFloorDetails?.floorCanvas.find(obj => obj._id === chairId);
                        return !matchingObject || matchingObject.tableId !== shape._id;
                    });

                    setSelectedTables(updatedSelectedObjects);
                    setSelectedChairs(filteredChairs)
                } else {

                    setSelectedTables([...selectedTables, shape._id]);

                    // Find matching Chairs based on the selected tableId 
                    const filteredIds = selectedFloorDetails?.floorCanvas
                        .filter((obj) => obj.tableId === shape._id)
                        .map((obj) => obj._id);

                    const uniqueIds = new Set(selectedChairs.concat(filteredIds));

                    setSelectedChairs([...uniqueIds]);
                }
            }
        }
    }   

// Order add api calls
    const addOrderFloorPlan=()=>{
        const payload={
            branchId: userInfo?.branchPk,
            tableId:selectedTables,
            chairId:selectedChairs,
            orderDate:`${today} ${getCurrentTime()}`,
            cusId:customer?._id || defaultCustomer?._id,
            subTotal: 0,
            amtTotal: 0,
            floorId:floorId
        }


        addOrderFromFloorAPI(payload)
    }

// Table transfer
    const updateTableSelected=()=>{
        const payload={
            orderId: orderIdForPos,
            tableId:selectedTables,
            chairId:selectedChairs,
            branchId: userInfo?.branchPk,
            floorId:floorId
        }

        if(selectedTables.length===0){
            dispatch(setSnackMsg("No seats selected !!"))
            dispatch(setErrorSnack(true))
        }else{
            updateOrderTablesAPI(payload)
        }
    }
// update case when multiple order enabled
    const updateMultiOrder=(id)=>{
        dispatch(setOrderIdInPOS(id))
        setTimeout(() => {
            updateOrderFloorPlan()
        }, 0);
    }
    const updateOrderFloorPlan=()=>{
        dispatch(setBtnSelected(null))
    }

    const getRandomColor = () => {
        const generateRandomValue = () => Math.floor(Math.random() * 200); 
        const color = `rgb(${generateRandomValue()}, ${generateRandomValue()}, ${generateRandomValue()})`;
    
        return color;
    };

    // Fn to get the orderId of relative table
    const getFirstObject=(list)=>{
        if(list.length!==0){
            return list[0]?._id
        }else{
            return null
        }
    }
// effect to set tableId according to the chair selected
    useEffect(()=>{
        if(selectedChairs.length!==0){
            const chairNames = selectedFloorDetails?.floorCanvas
            .filter(obj => selectedChairs.includes(obj._id))
            .map(obj => obj.tableId);
            const uniqueTableIds = [...new Set(chairNames)];

            setSelectedTables(uniqueTableIds);
        }
    },[selectedChairs])

    // color setting of selected table in case of already existing order
    useEffect(() => {
        if (Object.keys(initialColors).length === 0) {
          setInitialColors(orderIdColorMapping);
        } else {
          setOrderIdColorMapping(initialColors);
        }
      
        const newColorValue = "rgb(255, 0, 0)";
      
        setOrderIdColorMapping((prevColors) => {
          if (prevColors.hasOwnProperty(orderIdForPos)) {
            // Update the color value for the orderIdForPos key
            return { ...prevColors, [orderIdForPos]: newColorValue };
          } else {
            return prevColors;
          }
        });
      }, [orderIdForPos]);

    //   initially getting the default floor info
      useEffect(()=>{

        const index = floors.findIndex(obj => obj._id === defaultFloorId);

        if(floors?.length!==0){
            let inFloor=index>=0?index:false;
            setFloorSelected(inFloor || 0)
            dispatch(setSelectedElementDetails({ ...floors[inFloor || 0], isFloor: true }));
            getFloorDetailsForBilling({ id: floors[inFloor || 0]?._id,branchId:userInfo?.branchPk });
            setFloorId(floors[inFloor || 0]?._id || null)
        }
      },[floors])

    //   tableChange case
      useEffect(()=>{
        if(btnClicked==="tableChange"){
            setSelectedChairs(singleOrderInfo?.chairId || [])
            if(singleOrderInfo?.chairId.length===0){
                setSelectedTables(singleOrderInfo?.tableId || [])
            }
            // setFloorRendered(true)
        }
      },[])


    //   Setting Orders under the selectedTable
    useEffect(()=>{
        let orderLists=selectedFloorDetails?.floorCanvas?.filter((obj)=>(
            selectedTables.includes(obj?._id)
        ))?.reduce((acc, obj) => acc.concat(obj.orders), []);
        setTableOrders(orderLists)
    },[selectedTables])

  return (
      <div className='billing-main-container'>
          <div className="billing-left-container" style={{width:"100%"}}>
            {/* <TopBar/> */}
            <div className="flex-row" style={{gap:"5px"}}>
              <div className='justify-center' style={{backgroundColor:"#fff",width:"40px"}}>
                  <IconButton
                    onClick={()=>{
                        dispatch(setBtnSelected(null))
                        dispatch(setOrderIdInPOS(null))
                    }}
                    >
                      <HomeIcon sx={{ color: "green" }} />
                  </IconButton>
              </div>
              <TopBar />
          </div>
              <div className="add-seat-wrapper" style={{ margin: "5px 0", height: "85vh",position:"relative" }}>
                  <Box
                      sx={{ maxWidth: "100%", width: "100%", bgcolor: "background.paper" }}
                  >
                      <Tabs
                          value={floorSelected}
                          onChange={(e, newValue) =>{ 
                            setFloorSelected(newValue)
                        }}
                          variant="scrollable"
                          scrollButtons="auto"
                          aria-label="scrollable auto tabs example"
                          className="floor-container"
                          sx={{
                              "& .MuiTabs-indicator": {
                                  backgroundColor: `${"red"} !important`,
                              },
                          }}
                      >
                          {floors?.map((res, i) => (
                              <Tab
                                  key={i}
                                  sx={{
                                      backgroundColor:
                                          getSelectedTabColor(res?.color) || rgba("#f67878", 0.5),
                                      minWidth: floors?.length,
                                      color: "white",
                                      "&.Mui-selected": {
                                          backgroundColor: res?.color || "#f67878",
                                          color: "white",
                                      },
                                      minWidth: tabWidth
                                  }}
                                  className="floor-box"
                                  label={res?.nameOfFloor}
                                  onClick={() => handleTabDetails(res)}
                              />
                          ))}
                      </Tabs>
                      {
                          floorLoading ?
                              <div className="center-div">
                                  <CircularProgress size={100} color="primary" sx={{ outline: "none" }} />
                              </div>
                              :
                              <>
                                  {!floorSelected === null ? <div className="center-div">Select a floor</div> :
                                      <>
                                          {
                                              (!selectedFloorDetails?.floorCanvas || selectedFloorDetails?.floorCanvas?.length === 0) ? <div className="center-div">No Floor plan added</div> :
                                                  <div className="tab-panel-container">
                                                      <div
                                                          className="sub-tab-wrapper"
                                                      >
                                                          {selectedFloorDetails?.floorCanvas?.map((shape) => (
                                                              <Rnd
                                                                  key={shape?._id || Math.random()}
                                                                  size={{
                                                                      width: shape?.size?.width || 50,
                                                                      height: shape?.size?.height || 50,
                                                                  }}
                                                                  position={{
                                                                      x: shape?.position?.x || 0,
                                                                      y: shape?.position?.y || 0,
                                                                  }}
                                                                  minWidth={10}
                                                                  minHeight={10}
                                                                  bounds="parent"
                                                                //   onTouchStart={()=>btnClicked==="tableChange"?tableShiftClicked(shape): handleShapeSelected(shape)}
                                                                  onClick={()=>btnClicked==="tableChange"?tableShiftClicked(shape): handleShapeSelected(shape)}
                                                                  enableResizing={false}
                                                                  disableDragging={true}
                                                              >
                                                                  {
                                                                    
                                                                      shape?.type === shapeTypes.SHAPE ? (
                                                                          <div
                                                                              className="shape-container "
                                                                              style={{ border: "transparent" }}
                                                                          >
                                                                              {shape?.structure === structures.LINESEGMENTTOOL ? (
                                                                                  <LineSegmentTool
                                                                                      color={shape?.color || "#656f75"}
                                                                                      width={shape?.size?.width || 50}
                                                                                      height={shape?.size?.height || 50}
                                                                                  />
                                                                              ) : shape?.structure === structures.SPLITFLOOR ? (
                                                                                  <div
                                                                                      className="shape-container"
                                                                                      style={{
                                                                                          backgroundColor: shape?.color || "#656f75",
                                                                                      }}
                                                                                  />
                                                                              ): shape?.structure === structures.HORIZONTAL ? (
                                                                                <div
                                                                                  className="shape-container"
                                                                                  style={{
                                                                                    backgroundColor: shape?.color || "#656f75",
                                                                                  }}
                                                                                />
                                                                              ) : shape?.structure === structures.STAR ? (
                                                                                  <StarTool
                                                                                      color={shape?.color || "#656f75"}
                                                                                      width={shape?.size?.width || 50}
                                                                                      height={shape?.size?.height || 50}
                                                                                  />
                                                                              ) : null}
                                                                          </div>
                                                                      ) : shape?.type === shapeTypes.TABLE ? (
                                                                            <>
                                                                          {btnClicked==="tableChange"?
                                                                            <div
                                                                              className={`shape-container ${shape?.structure || ''}`}
                                                                              style={{
                                                                                background: shape?.texture && textureStyles[shape?.texture] 
                                                                                  ? textureStyles[shape?.texture] 
                                                                                  : (((!(getFirstObject(shape?.orders)===orderIdForPos || !(getFirstObject(shape?.orders) &&  !(branchConfigurationList?.enableMultipleOrder)))))?(
                                                                                    orderIdColorMapping[getFirstObject(shape?.orders)] || (setOrderIdColorMapping((prevMapping) => ({ ...prevMapping, [getFirstObject(shape?.orders)]: getRandomColor() })), orderIdColorMapping[getFirstObject(shape?.orders)])
                                                                                ):
                                                                                 (shape?.color || '#80808082')),
                                                                                transform: `rotate(${shape?.rotation || 0}deg)`,
                                                                                cursor: "pointer",
                                                                                position: "relative",
                                                                                border: selectedTables.includes(shape?._id) ? '3px solid #e91d1d' : 'none',
                                                                                boxShadow: selectedTables.includes(shape?._id) ? '0 0 10px rgba(233, 29, 29, 0.6)' : 'none',
                                                                                boxSizing: 'border-box'
                                                                              }}
                                                                              >
                                                                              <span style={{ transform: `rotate(-${shape?.rotation || 0}deg)` }}>{shape?.name || ''}</span>
                                                                              {/* Bill number and KOT icon for tables with orders */}
                                                                              {shape?.orders?.length > 0 && (
                                                                                <div 
                                                                                  style={{
                                                                                    position: 'absolute',
                                                                                    top: '-8px',
                                                                                    right: '-8px',
                                                                                    display: 'flex',
                                                                                    flexDirection: 'column',
                                                                                    gap: '2px',
                                                                                    transform: `rotate(-${shape?.rotation || 0}deg)`,
                                                                                    zIndex: 10,
                                                                                  }}
                                                                                >
                                                                                  {shape?.orders?.map((order, idx) => {
                                                                                    const delayColors = getOrderDelayColors(order?.orderDate, order?.orderTime);
                                                                                    // Debug log
                                                                                    if (idx === 0) console.log('🕐 Order delay (tableChange):', { orderName: order?.orderName, orderDate: order?.orderDate, orderTime: order?.orderTime, colors: delayColors });
                                                                                    return (
                                                                                    <div
                                                                                      key={order?._id || idx}
                                                                                      style={{
                                                                                        display: 'flex',
                                                                                        alignItems: 'center',
                                                                                        gap: '2px',
                                                                                        background: delayColors.background,
                                                                                        borderRadius: '4px',
                                                                                        padding: '2px 4px',
                                                                                        boxShadow: '0 1px 3px rgba(0,0,0,0.3)',
                                                                                        cursor: 'pointer'
                                                                                      }}
                                                                                      onDoubleClick={(e) => {
                                                                                        e.stopPropagation();
                                                                                        if (order) {
                                                                                          dispatch(setOrderIdInPOS(order._id));
                                                                                          dispatch(setSingleOrderInfo(order));
                                                                                          dispatch(setBtnSelected("payment"));
                                                                                        }
                                                                                      }}
                                                                                      title="Double-click to pay"
                                                                                    >
                                                                                      <ReceiptIcon sx={{ fontSize: 12, color: delayColors.iconColor }} />
                                                                                      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', lineHeight: 1.2 }}>
                                                                                        <span style={{ fontSize: '9px', fontWeight: 'bold', color: delayColors.textColor }}>
                                                                                          {order?.orderName || order?.orderId || 'Bill'}
                                                                                        </span>
                                                                                        {order?.kotName && (
                                                                                          <span style={{ fontSize: '8px', color: delayColors.kotColor, fontWeight: '500' }}>
                                                                                            KOT: {order?.kotName}
                                                                                          </span>
                                                                                        )}
                                                                                      </div>
                                                                                    </div>
                                                                                  )})}
                                                                                </div>
                                                                              )}
                                                                          </div>:
                                                                            <div
                                                                              className={`shape-container ${shape?.structure || ''}`}
                                                                              style={{
                                                                                background: shape?.texture && textureStyles[shape?.texture] 
                                                                                  ? textureStyles[shape?.texture] 
                                                                                  : ((getFirstObject(shape?.orders) &&  !(branchConfigurationList?.enableMultipleOrder))?(
                                                                                    orderIdColorMapping[getFirstObject(shape?.orders)] || (setOrderIdColorMapping((prevMapping) => ({ ...prevMapping, [getFirstObject(shape?.orders)]: getRandomColor() })), orderIdColorMapping[getFirstObject(shape?.orders)])
                                                                                ):
                                                                                 (shape?.color || '#80808082')),
                                                                                transform: `rotate(${shape?.rotation || 0}deg)`,
                                                                                cursor: "pointer",
                                                                                position: "relative",
                                                                                border: selectedTables.includes(shape?._id) ? '3px solid #e91d1d' : 'none',
                                                                                boxShadow: selectedTables.includes(shape?._id) ? '0 0 10px rgba(233, 29, 29, 0.6)' : 'none',
                                                                                boxSizing: 'border-box'
                                                                              }}
                                                                              >
                                                                              <span style={{ transform: `rotate(-${shape?.rotation || 0}deg)` }}>{shape?.name || ''}</span>
                                                                              {/* Bill number and KOT icon for tables with orders */}
                                                                              {shape?.orders?.length > 0 && (
                                                                                <div 
                                                                                  style={{
                                                                                    position: 'absolute',
                                                                                    top: '-8px',
                                                                                    right: '-8px',
                                                                                    display: 'flex',
                                                                                    flexDirection: 'column',
                                                                                    gap: '2px',
                                                                                    transform: `rotate(-${shape?.rotation || 0}deg)`,
                                                                                    zIndex: 10,
                                                                                  }}
                                                                                >
                                                                                  {shape?.orders?.map((order, idx) => {
                                                                                    const delayColors = getOrderDelayColors(order?.orderDate, order?.orderTime);
                                                                                    return (
                                                                                    <div
                                                                                      key={order?._id || idx}
                                                                                      style={{
                                                                                        display: 'flex',
                                                                                        alignItems: 'center',
                                                                                        gap: '2px',
                                                                                        background: delayColors.background,
                                                                                        borderRadius: '4px',
                                                                                        padding: '2px 4px',
                                                                                        boxShadow: '0 1px 3px rgba(0,0,0,0.3)',
                                                                                        cursor: 'pointer'
                                                                                      }}
                                                                                      onDoubleClick={(e) => {
                                                                                        e.stopPropagation();
                                                                                        if (order) {
                                                                                          dispatch(setOrderIdInPOS(order._id));
                                                                                          dispatch(setSingleOrderInfo(order));
                                                                                          dispatch(setBtnSelected("payment"));
                                                                                        }
                                                                                      }}
                                                                                      title="Double-click to pay"
                                                                                    >
                                                                                      <ReceiptIcon sx={{ fontSize: 12, color: delayColors.iconColor }} />
                                                                                      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', lineHeight: 1.2 }}>
                                                                                        <span style={{ fontSize: '9px', fontWeight: 'bold', color: delayColors.textColor }}>
                                                                                          {order?.orderName || order?.orderId || 'Bill'}
                                                                                        </span>
                                                                                        {order?.kotName && (
                                                                                          <span style={{ fontSize: '8px', color: delayColors.kotColor, fontWeight: '500' }}>
                                                                                            KOT: {order?.kotName}
                                                                                          </span>
                                                                                        )}
                                                                                      </div>
                                                                                    </div>
                                                                                  )})}
                                                                                </div>
                                                                              )}
                                                                          </div>
                                                                          
                                                                          }
                                                                              </>
                                                                      ) : shape?.type === shapeTypes.DECOR ? (
                                                                          <div
                                                                              className="decor-container"
                                                                              style={{
                                                                                transform: `rotate(${shape?.rotation || 0}deg)`,
                                                                              }}
                                                                          >
                                                                              {shape?.decorType === decorTypes.PLANT ? (
                                                                                <PlantIcon
                                                                                  color={shape?.color || "#4CAF50"}
                                                                                  width={shape?.size?.width || 50}
                                                                                  height={shape?.size?.height || 50}
                                                                                  name={shape?.name || ''}
                                                                                />
                                                                              ) : shape?.decorType === decorTypes.TREE ? (
                                                                                <TreeIcon
                                                                                  color={shape?.color || "#2E7D32"}
                                                                                  width={shape?.size?.width || 50}
                                                                                  height={shape?.size?.height || 50}
                                                                                  name={shape?.name || ''}
                                                                                />
                                                                              ) : shape?.decorType === decorTypes.FLOWER ? (
                                                                                <FlowerIcon
                                                                                  color={shape?.color || "#E91E63"}
                                                                                  width={shape?.size?.width || 50}
                                                                                  height={shape?.size?.height || 50}
                                                                                  name={shape?.name || ''}
                                                                                />
                                                                              ) : shape?.decorType === decorTypes.FOUNTAIN ? (
                                                                                <FountainIcon
                                                                                  color={shape?.color || "#2196F3"}
                                                                                  width={shape?.size?.width || 50}
                                                                                  height={shape?.size?.height || 50}
                                                                                  name={shape?.name || ''}
                                                                                />
                                                                              ) : shape?.decorType === decorTypes.STATUE ? (
                                                                                <StatueIcon
                                                                                  color={shape?.color || "#9E9E9E"}
                                                                                  width={shape?.size?.width || 50}
                                                                                  height={shape?.size?.height || 50}
                                                                                  name={shape?.name || ''}
                                                                                />
                                                                              ) : shape?.decorType === decorTypes.LAMP ? (
                                                                                <LampIcon
                                                                                  color={shape?.color || "#FFC107"}
                                                                                  width={shape?.size?.width || 50}
                                                                                  height={shape?.size?.height || 50}
                                                                                  name={shape?.name || ''}
                                                                                />
                                                                              ) : (
                                                                                <PlantIcon
                                                                                  color={shape?.color || "#4CAF50"}
                                                                                  width={shape?.size?.width || 50}
                                                                                  height={shape?.size?.height || 50}
                                                                                  name={shape?.name || ''}
                                                                                />
                                                                              )}
                                                                          </div>
                                                                      ) : shape?.type === shapeTypes.CHAIR ? (
                                                                          <div
                                                                              className="chair-container"
                                                                              style={{ 
                                                                                cursor: "pointer",
                                                                                transform: `rotate(${shape?.rotation || 0}deg)`,
                                                                              }}
                                                                          >
                                                                              <Chair
                                                                                  color={
                                                                                    btnClicked==="tableChange"?
                                                                                    ((!(getFirstObject(shape?.orders)===orderIdForPos || !(getFirstObject(shape?.orders) &&  !(branchConfigurationList?.enableMultipleOrder))))?(
                                                                                        orderIdColorMapping[getFirstObject(shape?.orders)] || (setOrderIdColorMapping((prevMapping) => ({ ...prevMapping, [getFirstObject(shape?.orders)]: getRandomColor() })), orderIdColorMapping[getFirstObject(shape?.orders)])
                                                                                    ):
                                                                                     (selectedChairs.includes(shape?._id) ? 'red' : (shape?.color || '#80808082'))):
                                                                                    ((getFirstObject(shape?.orders) &&  !(branchConfigurationList?.enableMultipleOrder))?(
                                                                                        orderIdColorMapping[getFirstObject(shape?.orders)] || (setOrderIdColorMapping((prevMapping) => ({ ...prevMapping, [getFirstObject(shape?.orders)]: getRandomColor() })), orderIdColorMapping[getFirstObject(shape?.orders)])
                                                                                    ):
                                                                                     (selectedChairs.includes(shape?._id) ? 'red' : (shape?.color || '#80808082')))
                                                                                  }
                                                                                  width={shape?.size?.width || 25}
                                                                                  name={shape?.name || ''}
                                                                                  height={shape?.size?.height || 25}
                                                                              />
                                                                          </div>
                                                                      ) : null
                                                                  }
                                                              </Rnd>
                                                          ))}
                                                      </div>
                                                  </div>}
                                      </>
                                  }
                              </>}
                  </Box>

                  {
                (selectedChairs.length!==0 || selectedTables.length!==0 || orderIdForPos!==null) &&    
                <div className="button-container-floorPlan">
                    {
                        btnClicked==="tableChange"?
                        <button 
                    className="btn btn-primary"
                     onClick={updateTableSelected}>{"Transfer Table"}</button>
                        :<button 
                    className="btn btn-primary"
                     onClick={orderIdForPos===null? addOrderFloorPlan :updateOrderFloorPlan}>{orderIdForPos===null?"Add Order":"Update Order"}</button>
                  }

                {tableOrder?.length!==0 && branchConfigurationList?.enableMultipleOrder &&
                  <div className="multi-order-update-ctn">
                  {    
                    tableOrder?.filter((item, index, self) => 
                        index === self.findIndex((t) => t._id === item._id)
                      )?.map((item,i)=>(
                        <div className="order-ctn justify-space-between">
                            <p>{item?.orderName}</p>
                            <button 
                             className="btn btn-primary"
                             onClick={()=>updateMultiOrder(item?._id)}>
                            <i className="bi bi-pencil-square edit-icon"></i>
                            </button>
                        </div>
                    ))
                  }
                  </div>}
                </div>
                  }
              </div>
          </div>
      </div>
  )
}

export default BillingFloorPlan